 <template>
  <div class="">
    <div class="">
      <div class="upper-parent">
        <div class="upper-parent-child1">
          <div class='same-line itemsContainer inline-block'>
            <div class='offer-name'>
              <div v-if="gettersSelectedOffer && gettersSelectedOffer.name">
                {{ this.gettersSelectedOffer.name }}
              </div>
              <div v-if="duplicatedItemName && duplicatedItemName.name" class="item-text">
                {{ duplicatedItemName.name }}
              </div>
            </div>
            <searchable-dropdown
            id='simulation1'
            :list='itemArrays'
            v-model='selectedItem'
            :selectedItem="selectedItem ? selectedItem.name : ''">
            </searchable-dropdown>
          </div>
        </div>
        <div class="upper-parent-child2">
          <div
            class="marginLeft inline-block"
            :style="{'width': '90%'}">
            <div class="margin-top-3">
              <span class="slider-title">
                Vendor Allowance
              </span>
              <div class="marginRight padding1">
                <vue-slider
                v-model='slider1Value'
                :data ='slider1Data'
                :refresh='refresh'
                :width ="width"
                :tooltip ='true'
                :disabled ='slider1Disabled'
                :piecewise ='true'
                :piecewiseLabel ='true'
                :piecewiseStyle = 'piecewiseStyle'
                :piecewiseActiveStyle = 'piecewiseActiveStyle'
                :labelActiveStyle = 'labelActiveStyle'
                :processStyle='processStyle'
                :style='style'
                >
                </vue-slider>
              </div>
            </div>
            <span>
              <span class="slider-title">Retail Savings</span>
              <div class="marginRight padding1">
                <vue-slider
                v-model='slider2Value'
                :data ='slider2Data'
                :width ="width"
                :tooltip ='true'
                :disabled ='false'
                :piecewise ='true'
                :piecewiseLabel ='true'
                :piecewiseStyle = 'piecewiseStyle'
                :piecewiseActiveStyle = 'piecewiseActiveStyle'
                :labelActiveStyle = 'labelActiveStyle'
                :processStyle='processStyle'
                :style='style'
                >
                </vue-slider>
              </div>
            </span>
          </div>
        </div>
      </div>

      <div id='table1ContainerDiv' class="table1-space">
        <div class="inline-block v-top text-align-left" id='table1HeaderContainer'>
          <data-table :data='table1Header' :styles='tableStyles.offersListHeaderStyles'></data-table>
        </div>
        <div id='table1BodyContainer' class="inline-block scrollable" :style='{width: scrollable1Width}'>
          <div class="inline-block text-align-left" :style='{width: `${table1Data.length * table1BodyWidth}rem`}'>
            <div
              class="inline-block"
              v-for='data in table1Data'
              :style='{width: `${table1BodyWidth}rem`, "vertical-align":"top"}'>
              <data-table :functions='updateChanges' :data='data' :styles='tableStyles.offersListDataStyle'></data-table>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <button
          type="button"
          @click='submitChanges'
          :class="{'width_4': true, 'primary-green-bg': hasChanges, 'light-grey-text': !hasChanges}"
          :disabled='!hasChanges'>
            Submit changes
        </button>
      </div>
  	</div>
    <div class="change-header-title">
      {{ 'Impact Of Changing Retail Savings' }}
    </div>
    <div class="switch-parent">
      <span :class='{"padding1": true, "color": !switchToggle}'>Graph</span>
      <label class="switch">
        <input type="checkbox" v-model='switchToggle'>
        <div class="slider"></div>
      </label>
      <span :class='{"padding1": true, "color": switchToggle}'>Table</span>
    </div>
    <div v-if='switchToggle'>
      <div class="table1-space" id='table2ContainerDiv'>
        <div class="inline-block v-top text-align-left" id='table2HeaderContainer'>
          <data-table :data='table2Headers' :styles='tableStyles.offersListHeaderStyles'></data-table>
        </div>
        <div id='table2BodyContainer' class="inline-block scrollable text-align-left" :style='{width: scrollable2Width}'>
          <div class="inline-block" :style='{width: `${table2Data.length * scrollableChildrenWidth}rem`}'>
            <div
              class="inline-block"
              v-for='data in table2Data'
              :style='{width: `${scrollableChildrenWidth}rem`}'>
              <data-table :data='data' :styles='tableStyles.offersListDataStyle'></data-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="graph-parent" v-if='!switchToggle'>
      <div class="radio-container">
        <div v-for="data in lineChartInputOptionArray">
          <input type="radio" id='data' :value='data' v-model='picked'>
          <label :for="data">{{ data }}</label>
        </div>
      </div>
      <div class="graph-container">
        <vue-chart
          chart-type='LineChart'
          :columns='columns'
          :rows='rows'
          :options='options'>
        </vue-chart>
      </div>
    </div>
  </div>
</template>
<script>
// import { mockChartData } from './mock'
// import moment from 'moment'
import * as NameSpace from 'src/store/NameSpace'
import VueSlider from 'vue-slider-component'
import { mapGetters, mapActions } from 'vuex'
import { TableHeightByFixedWidth } from 'src/Services/tableLayoutHelper/height'
import { tableStyles } from './tableStyles'
import { mainContainerStyle } from 'src/components/pop-up/mainContainerStyle'
import DataTable from 'src/components/shared/flexTables/DataTable'
import HorizontalTable from 'src/components/shared/flexTables/HorizontalTable'
import SearchableDropdown from 'src/components/shared/SearchableDropDown'
import { sortBy, filter, cloneDeep, find, findIndex } from 'lodash'
import {
  // VENDOR_ALLOWANCE,
  // PSP_ALLOWANCE,
  VENDOR_ALLOWANCE_PERCENT,
  RETAIL_SAVING_PERCENT,
  PSP_ALLOWANCE,
  VENDOR_ALLOWANCE,
  RETAIL_SAVING,
  RETAIL_PRICE
} from 'src/constants/Constants'
// import { pick } from 'lodash'
// import { validateInputField } from 'src/Services/Validation'

export default {
  data () {
    return {
      tableStyles,
      mainContainerStyle,
      slider1Value: undefined,
      slider2Value: undefined,
      slider1Disabled: false,
      slider1CurrentValue: null,
      slider2CurrentValue: null,
      width: 'auto',
      tooltip: 'always',
      disabled: false,
      piecewise: true,
      piecewiseLabel: true,
      piecewiseStyle: {
        'backgroundColor': '#ccc',
        'visibility': 'visible',
        'width': '12px',
        'height': '12px'
      },
      style: {
        'marginLeft': '1.5rem'
      },
      piecewiseActiveStyle: {
        'backgroundColor': '#05983b'
      },
      labelActiveStyle: {
        'color': '#05983b'
      },
      processStyle: {
        'backgroundColor': '#05983b'
      },
      scrollable2Width: '0px',
      scrollable1Width: '0px',
      scrollableChildrenWidth: 15,
      table1BodyWidth: 25,
      table1Header: [],
      type: 'record',
      table1Data: [],
      slider1Data: [],
      slider2Data: [],
      currentDecision: null,
      simulation: [],
      originalData: {},
      table1Column: [],
      switchToggle: false,
      mappedKey: null,
      picked: '',
      rows: [],
      itemArrays: [],
      selectedItem: null,
      refresh: false,
      hasChanges: false,
      updatedData: {},
      duplicatedItemName: null,
      updateChanges: this.updateChanges,
      vaAllowancePercentPos: 0,
      retailSavingPercentPos: 0,
      pspAllowancePos: 0,
      vendorAllowancePos: 0,
      retailSavingPos: 0,
      validationMsg: 'Psp Allowance($) must be less than or equal to Retail Savings($).',
      homeRouterPath: '/pending-offers'
    }
  },
  beforeUpdate () {

  },
  components: {
    VueSlider,
    DataTable,
    HorizontalTable,
    SearchableDropdown
  },
  created () {
    this.itemArrays = this.offerItems
    this.selectedItem = this.itemArrays[0]
    if (!this.selectedItem) {
      this.$router.push(this.homeRouterPath)
    }
    this.duplicatedItemName = cloneDeep(this.selectedItem)
    // this.fetchLiftSimulation({ itemId: this.selectedItem.id, period: this.period })
  },
  watch: {
    gettersSelectedOffer () {
      console.log(this.gettersSelectedOffer)
      if (!this.gettersSelectedOffer.name) {
        console.log('-----------------')
      }
    },
    'gettersSubmittedDecision.isSuccess' () {
      if (this.gettersSubmittedDecision.isSuccess) {
        let warnings = this.gettersLiftSimulation.warnings
        if (warnings) {
          this.pop({
            header: 'WARNINGS',
            message: warnings.map(e => {
              let key = Object.keys(e).pop()
              return `${key}: ${e[key]}`
            })
          })
        } else {
          this.pop({
            header: 'Success!!',
            message: 'Submitted successfully.',
            type: 'SUCCESS'
          })
        }
      }
    },
    'gettersCalculationField.data' () {
      let data = this.gettersCalculationField.data
      if (data) {
        for (let i = 1; i < this.table1Header.length; i++) {
          let key = this.table1Header[i].key
          let val = data[key]
          // console.log(key, val)
          this.table1Data[1][i].value = val
        }
      }
      // const { index, value } = this.editedItemRecord
      // let tableColumn1 = this.table1Data[1]
      // let obj = {[VENDOR_ALLOWANCE_PERCENT]: tableColumn1[this.vaAllowancePercentPos].value, [RETAIL_SAVING_PERCENT]: tableColumn1[this.retailSavingPercentPos].value}
      // // console.log(obj)
      // let data = this.getOriginalData(obj)
      // // console.log(data)
      // this.performCalculation(data, tableColumn1, this.editedItemRecord)
      // let updatedKey = this.table1Header[index].key
      // // this.updatedData.itemId = this.duplicatedItemName.id
      // this.updatedData[updatedKey] = value
      // let keys = Object.keys(this.updatedData)
      // let notEmpty = false
      // if (keys.length) {
      //   for (let i = 0; i < keys.length; i++) {
      //     if (this.updatedData[keys[i]]) {
      //       notEmpty = true
      //     } else {
      //       notEmpty = false
      //       break
      //     }
      //   }
      //   if (notEmpty) {
      //     this.hasChanges = true
      //   } else {
      //     this.hasChanges = false
      //   }
      // } else {
      //   this.hasChanges = false
      // }
    },
    'gettersCalculationField.error' () {
      this.pop({
        header: 'UNKNOWN ERROR!!',
        message: this.gettersCalculationField.error,
        type: 'ERROR'
      })
    },
    switchToggle () {
      if (this.switchToggle) {
        this.$nextTick(function () {
          this.scrollable2Width = this.getTable2ContainerWidth()
        })
      }
    },
    selectedItem () {
      if (this.selectedItem && this.selectedItem.id) {
        this.duplicatedItemName = cloneDeep(this.selectedItem)
        this.resetLocalData()
        this.refresh = true
        this.fetchLiftSimulation({ storeLevel: this.storeLevel, itemId: this.selectedItem.id, period: this.period })
      }
    },
    picked () {
      this.$set(this.options, 'title', this.picked)
      if (this.mappedKey) {
        let keyToFilterBy = this.mappedKey[this.picked]
        this.setGraphRows(keyToFilterBy)
      }
    },
    'gettersLiftSimulation.data' () {
      let headers = this.gettersLiftSimulation.headers
      headers.splice(0, 0, {key: '\xa0', value: '\xa0'})
      this.table1Header = headers
      if (headers) {
        this.vaAllowancePercentPos = headers.map(e => { return e.key }).indexOf(VENDOR_ALLOWANCE_PERCENT)
        this.retailSavingPercentPos = headers.map(e => { return e.key }).indexOf(RETAIL_SAVING_PERCENT)
        this.pspAllowancePos = headers.map(e => { return e.key }).indexOf(PSP_ALLOWANCE)
        this.vendorAllowancePos = headers.map(e => { return e.key }).indexOf(VENDOR_ALLOWANCE)
        this.retailSavingPos = headers.map(e => { return e.key }).indexOf(RETAIL_SAVING)
        this.retailPricePos = headers.map(e => { return e.key }).indexOf(RETAIL_PRICE)
      }
      this.processData()
      if (this.mappedKey) {
        let keyToFilterBy = this.mappedKey[this.picked]
        this.setGraphRows(keyToFilterBy)
      }
    },
    'gettersLiftSimulation.error' () {
      if (Array.isArray(this.gettersLiftSimulation)) {
        this.pop({
          header: 'ERROR',
          message: this.gettersLiftSimulation.error.map(e => {
            let key = Object.keys(e).pop()
            return `${key}: ${e[key]}`
          }),
          type: 'ERROR'
        })
      } else {
        if (this.gettersLiftSimulation.error) {
          let msg = this.gettersLiftSimulation.error ? this.gettersLiftSimulation.error : 'Opps got unknown error'
          this.pop({
            header: 'ERROR!!',
            message: msg + ', please click back button.',
            type: 'ERROR'
          })
        }
      }
    },
    slider1Value () {
      this.updateTable1BySlider1Changes()
    },
    slider2Value () {
      this.updateTable1BySlider2Changes()
    }
  },
  computed: {
    ...mapGetters({
      gettersLiftSimulation: NameSpace.GET_LIFT_SIMULATION,
      gettersAggInputData: NameSpace.GET_AGG_INPUT_FILTER_DATA,
      gettersSelectedOffer: NameSpace.GET_SELECTED_OFFER_NAME,
      gettersOfferDetails: NameSpace.GET_OFFER_ITEMS,
      gettersRadioOption: NameSpace.GET_LINE_CHART_RADIO,
      gettersCalculationField: NameSpace.GET_CALCULATION_FIELDS,
      gettersSubmittedDecision: NameSpace.GET_SIMULATION_CHANGES
    }),
    simulationData () {
      this.resetLocalData()
      return this.gettersLiftSimulation.data
    },
    period () {
      return this.gettersAggInputData.period.id
    },
    storeLevel () {
      return this.gettersAggInputData.storeLevel.id
    },
    lineChartInputOptionArray () {
      if (this.gettersRadioOption) {
        let radioArrays = Object.keys(this.gettersRadioOption)
        if (radioArrays.length) {
          this.picked = radioArrays[0]
          return radioArrays
        }
      }
      return []
    },
    originalHeader () {
      let orignalHeader = this.gettersLiftSimulation.originalTableHeader
      if (orignalHeader) {
        return orignalHeader
      }
    },
    options () {
      return {
        legend: 'none',
        title: '',
        pointSize: 6,
        colors: ['#05983b'],
        hAxis: {
          title: 'Retail Savings($)',
          minValue: '0',
          maxValue: '4',
          slantedText: true,
          slantedTextAngle: 90
        },
        vAxis: {
          title: '',
          minValue: 0,
          maxValue: 1000,
          gridlines: {
            count: 15,
            color: 'none'
          }
        },
        height: 450,
        curveType: 'function'
      }
    },
    columns () {
      return [{
        'type': 'string',
        'label': 'Year'
      },
      {
        'type': 'number'
      }]
    },
    table2Headers () {
      let key = 'retailSavingsPercent'
      let tempHeader = cloneDeep(this.table1Header)
      let retObject, index
      for (let i = 0; i < tempHeader.length; i++) {
        let obj = tempHeader[i]
        if (obj.key === key) {
          retObject = obj
          index = i
          break
        }
      }
      tempHeader.splice(index, 1)
      tempHeader[0] = retObject
      return tempHeader
    },
    table2Data () {
      this.table2Data = []
      let a = []
      let key = 'retailSavingsPercent'
      let localArray = cloneDeep(this.originalData.simulation)
      localArray = filter(localArray, {'vendorAllowancePercent': this.slider1CurrentValue})
      localArray = sortBy(localArray, key)
      localArray.unshift(cloneDeep(this.originalData.currentDecision))
      localArray[0]['retailSavingsPercent'] = 'Current' + ' (' + this.originalData.currentDecision['retailSavingsPercent'] + '%)'
      localArray.forEach((data, j) => {
        // let header = this.slider2Data[c]
        let column = []
        let index
        let rsPercent
        let keyArray = Object.keys(data)
        for (let i = 0; i < keyArray.length; i++) {
          let eachKey = keyArray[i]
          if (eachKey === 'tagNo') {
            column.tagNo = data[eachKey]
            // delete data[eachKey]
            continue
          }
          if (key === eachKey) {
            index = i
            rsPercent = data[key]
          }
          if (!data[eachKey]) {
            data[eachKey] = 0
          }
          column.push(data[eachKey])
        }
        if (j === 0) {
          column.splice(0, 0, rsPercent)
        } else {
          column.splice(0, 0, rsPercent + '%')
        }
        column.splice(index + 1, 1)
        a.push(column)
        return a
      })
      return a
    },
    offerItems () {
      let parentArray = this.gettersOfferDetails.detailedData
      return parentArray.map((arr) => {
        return {name: arr[0], id: arr.itemId}
      })
    }
  },
  mounted () {
    this.tempMethod()
  },
  updated () {
    this.tempMethod()
  },
  methods: {
    ...mapActions({
      fetchLiftSimulation: NameSpace.FETCH_LIFT_SIMULATION,
      postSimulationChanges: NameSpace.POST_SIMULATION_CHANGES,
      pop: NameSpace.SET_MODAL_CONFIG_ACTION,
      fetchCalculationFields: NameSpace.FETCH_CALCULATION_FIELDS
    }),
    resetLocalData () {
      this.switchToggle = false
      this.table1Data = []
      this.table2Data = []
      this.slider1Value = undefined
      this.slider2Value = undefined
      this.slider1Disabled = false
      this.slider1CurrentValue = null
      this.slider2CurrentValue = null
      this.slider1Data = []
      this.slider2Data = []
    },
    updateSimulationDataLocally (modifiedData) {
      let index1 = findIndex(this.originalData.simulation, ['tagNo', modifiedData.tagNo])
      this.originalData.simulation[index1] = modifiedData
      let index2 = findIndex(this.simulation, ['tagNo', modifiedData.tagNo])
      this.simulation[index2] = modifiedData
    },
    submitChanges () {
      if (Object.keys(this.updatedData).length === 0) {
        this.updatedData[VENDOR_ALLOWANCE] = this.table1Data[1][this.vendorAllowancePos].value
      }
      this.updatedData.salesSave = this.table1Data[1][this.retailSavingPos].value
      let inputObj = {
        itemId: this.duplicatedItemName.id,
        storeLevel: this.storeLevel,
        period: this.period,
        updatedData: this.updatedData
      }
      // console.log(JSON.stringify(inputObj), this.table1Data[1])
      this.postSimulationChanges(inputObj)
    },
    updateTable1BySlider2Changes () {
      if (this.slider2Value !== undefined) {
        let rs = this.slider2Value
        let va = this.slider1Value === undefined ? this.slider1Data[0] : this.slider1Value
        let vaSliderValue
        if (va.startsWith('Current')) {
          vaSliderValue = this.slider1CurrentValue
        } else {
          vaSliderValue = va.slice(0, -1)
        }
        let suggestedColumn = this.filterArray(vaSliderValue, rs)
        this.modifySecondColumn(suggestedColumn)
      }
    },
    modifySecondColumn (suggestedColumn) {
      if (this.table1Data.length > 1 && this.table1Data[1]) {
        this.table1Data.splice(1, this.table1Data.length - 1)
      }
      if (suggestedColumn && suggestedColumn.length && Array.isArray(suggestedColumn[0])) {
        suggestedColumn.map((data) => {
          data.splice(0, 0, 'As per simulation suggestions')
          this.table1Data.push(data)
        })
      } else {
        suggestedColumn.splice(0, 0, 'As per simulation suggestions')
        this.table1Data.push(suggestedColumn)
      }
      this.tempMethod()
    },
    updateTable1BySlider1Changes () {
      if (this.slider1Value !== undefined) {
        let va = this.slider1Value
        let rs = this.slider2Value === undefined ? this.slider2Data[0] : this.slider2Value
        let rsSliderValue
        if (rs.startsWith('Current')) {
          rsSliderValue = this.slider2CurrentValue
        } else {
          rsSliderValue = rs.slice(0, -1)
        }
        let suggestedColumn = this.filterArray(va, rsSliderValue)
        this.modifySecondColumn(suggestedColumn)
      }
    },
    tempMethod () {
      // this.orginalTable1Data = cloneDeep(this.table1Data)
      if (this.table1Data.length <= 4) {
        this.scrollable1Width = (this.table1Data.length * 10) * this.table1BodyWidth + 10 + 'px'
      } else {
        this.scrollable1Width = this.getTable1ContainerWidth()
      }
    },
    processData () {
      let fetchData = this.simulationData
      const { currentDecision, simulation } = fetchData
      if (fetchData) {
        if (this.gettersRadioOption) {
          this.mappedKey = this.gettersRadioOption
        }
        if (currentDecision) {
          this.originalData.currentDecision = currentDecision
          let tagNo = currentDecision.tagNo
          delete currentDecision['tagNo']
          let tempArray = Object.keys(currentDecision).map(function (k) {
            if (!currentDecision[k]) {
              currentDecision[k] = 0
            }
            return currentDecision[k]
          })
          this.slider1CurrentValue = currentDecision['vendorAllowancePercent']
          this.slider2CurrentValue = currentDecision['retailSavingsPercent']

          tempArray.splice(0, 0, 'As per currrent suggestions')
          tempArray.tagNo = tagNo
          this.table1Data.push(tempArray)
        }
        if (simulation) {
          this.simulation = simulation
          // let firstObjet = this.simulation[0]
          // let foundArray = []
          // foundArray = this.formTableData(firstObjet, foundArray)
          // console.log(foundArray)
          // foundArray.splice(0, 0, 'As per simulation suggestions')
          // this.table1Data.push(foundArray)
          this.originalData.simulation = simulation
          let pickData1 = []
          let pickData2 = []
          for (let i = 0; i < simulation.length; i++) {
            let obj = simulation[i]
            let va = obj['vendorAllowancePercent']
            if (va) {
              this.binaryInsert(va, pickData1)
            }
            if (obj['retailSavingsPercent']) {
              this.binaryInsert(obj['retailSavingsPercent'], pickData2)
            }
          }
          this.binaryInsert(this.slider1CurrentValue, pickData1)
          this.slider1Data = pickData1
          if (this.slider1Data.length === 1) {
            this.slider1Disabled = true
            this.slider1Data = [0, this.slider1Data[0]]
          }
          let currentIndex1 = this.slider1Data.indexOf(this.slider1CurrentValue + '%')
          this.slider1Data[currentIndex1] = `Current(${this.slider1CurrentValue}%)`
          if (this.slider1Value === undefined) {
            this.slider1Value = this.slider1Data[currentIndex1]
          }

          this.binaryInsert(this.slider2CurrentValue, pickData2)
          this.slider2Data = pickData2
          let currentIndex2 = this.slider2Data.indexOf(this.slider2CurrentValue + '%')
          this.slider2Data[currentIndex2] = `Current(${this.slider2CurrentValue}%)`
          if (this.slider2Value === undefined) {
            this.slider2Value = this.slider2Data[currentIndex2]
          }
        }
      }
    },
    performCalculation (newArray, record) {
      // let keysArray = Object.keys(oldObj)
      let newValueOfModifiedKey = Number(record.value)
      let modifiedKey = this.table1Header[record.index].key
      // let oldValueOfModifiedKey = oldObj[modifiedKey]
      let retailSaving = Number(newArray[this.retailSavingPos].value)
      if (modifiedKey === VENDOR_ALLOWANCE) {
        let retailPrice = Number(newArray[this.retailPricePos].value)
        if (newValueOfModifiedKey < 0) {
          return {opt: true, msg: this.validationMsg}
        } else if (newValueOfModifiedKey > retailPrice) {
          return { opt: true, msg: 'Vendor Allowance($' + newValueOfModifiedKey + ') must be less than Retail Price($' + retailPrice + ').' }
        }
        // let delta = (Number(oldValueOfModifiedKey) - pspAllowance).toFixed(2)
      } else if (modifiedKey === PSP_ALLOWANCE) {
        let delta = retailSaving - newValueOfModifiedKey
        if (newValueOfModifiedKey > retailSaving) {
          return { opt: true, msg: 'Psp Allowance($' + newValueOfModifiedKey + ') must be less than Retail Savings($' + retailSaving + ').' }
        } else {
          let key = (this.table1Header[this.vendorAllowancePos]).key
          this.updatedData[key] = delta
        }
      }
      return {opt: false}

      // for (let j = 1; j <= keysArray.length; j++) {
      //   let key = (this.table1Header[j]).key
      //   let value = oldObj[key]
      //   if (!value) {
      //     value = 0
      //   }
      //   let newObj = newArray[j]
      //   value = Number(value)
      //   let newValue = Number(newObj.value)
      //   let delta = (value - newValue).toFixed(2)
      //   console.log('KEY::', key)
      //   console.log('Old:', Number(value), 'New:', newValue)
      //   console.log('Diff:', value - newValue)
      //   if (modifiedKey === VENDOR_ALLOWANCE) {
      //     value = value + delta
      //     console.log(newObj)
      //   } else if (modifiedKey === PSP_ALLOWANCE) {
      //     value = value + delta
      //     console.log(newObj)
      //   }
      // }
    },
    formTableData (obj, foundArray) {
      let tagNo
      let cloneObj = cloneDeep(obj)
      if (obj.hasOwnProperty('tagNo')) {
        tagNo = cloneObj['tagNo']
        delete cloneObj['tagNo']
      }
      let keysArray = Object.keys(cloneObj)
      for (let j = 1; j <= keysArray.length; j++) {
        if (keysArray[j] === 'tagNo') {
          continue
        }
        let key = (this.table1Header[j]).key
        // console.log(key)
        let value = cloneObj[key]
        if (!value) {
          value = 0
        }
        let editable = false
        editable = this.isEditableOrNot(key)
        if (editable) {
          foundArray.push({value, editable, index: j, clickAway: true})
        } else {
          foundArray.push({value, editable, index: j})
        }
      }
      foundArray.tagNo = tagNo
      return foundArray
    },
    binaryInsert (value, array, startVal, endVal) {
      if (!value) {
        value = 0
      }
      // console.log('-------------------', array)
      let length = array.length
      let start = typeof (startVal) !== 'undefined' ? startVal : 0
      let end = typeof (endVal) !== 'undefined' ? endVal : length - 1 // !! endVal could be 0 don't use || syntax
      let m = start + Math.floor((end - start) / 2)
      // console.log('startIndex:', start, 'endIndex:', end, 'mIndex:', m)
      if (length === 0) {
        array.push(value + '%')
        return
      }
      let endItem = array[end].slice(0, -1)
      let startItem = array[start].slice(0, -1)
      let mItem = array[m].slice(0, -1)
      // console.log('value:', value, 'startItem:', startItem, 'endItem:', endItem, 'mItem:', mItem)
      if (value > endItem) {
        array.splice(end + 1, 0, value + '%')
        return
      }
      if (value < startItem) {
        array.splice(start, 0, value + '%')
        return
      }
      if (start >= end) {
        return
      }
      if (value < mItem) {
        this.binaryInsert(value, array, start, m - 1)
        return
      }
      if (value > mItem) {
        this.binaryInsert(value, array, m + 1, end)
        return
      }
    },
    getOriginalData (modifyData) {
      return find(this.originalData.simulation, modifyData)
    },
    filterArray (va, rs) {
      let currentVaPercent = this.originalData.currentDecision[VENDOR_ALLOWANCE_PERCENT]
      let currentRsPercent = this.originalData.currentDecision[RETAIL_SAVING_PERCENT]

      this.hasChanges = false
      this.updatedData = {}
      let simulation = this.originalData.simulation
      let arrayOfSimSugg = []
      va = Number(va.toString().replace(/[^0-9\\.]+/g, ''))
      this.slider1CurrentValue = va

      rs = Number(rs.toString().replace(/[^0-9\\.]+/g, ''))
      this.slider2CurrentValue = rs

      if ((currentVaPercent !== this.slider1CurrentValue) || (currentRsPercent !== this.slider2CurrentValue)) {
        this.hasChanges = true
      } else {
        this.hasChanges = false
      }

      for (let i = 0; i < simulation.length; i++) {
        let obj = simulation[i]
        if (obj['vendorAllowancePercent'] === va && obj['retailSavingsPercent'] === rs) {
          let foundArray = []
          foundArray = this.formTableData(obj, foundArray)
          arrayOfSimSugg.push(foundArray)
        }
      }
      if (arrayOfSimSugg.length) {
        return arrayOfSimSugg
      } else {
        let emptyArray = []
        for (let k = 0; k < this.table1Header.length; k++) {
          let key = (this.table1Header[k]).key
          if (key && key.trim()) {
            emptyArray.push({value: 0, editable: false, index: k, clickAway: true})
          }
        }
        return emptyArray
      }
    },
    isEditableOrNot (key) {
      let obj = this.originalHeader[key]
      if (obj) {
        if (obj.fn.includes('makeEditable')) {
          return true
        }
      }
      return false
    },
    setGraphRows (filterUnit) {
      let localArray = cloneDeep(this.originalData.simulation)
      localArray = filter(localArray, {'vendorAllowancePercent': this.slider1CurrentValue})
      localArray = sortBy(localArray, 'retailSavingsPercent')
      let data = localArray.map((simulation) => {
        return [simulation.retailSavings.toString(), simulation[filterUnit] ? simulation[filterUnit] : 0]
      })
      this.rows = data
    },
    getTable2ContainerWidth () {
      try {
        if (
          document.getElementById('table2ContainerDiv') &&
          document.getElementById('table2HeaderContainer')
        ) {
          let tableContainerDiv = document.getElementById('table2ContainerDiv').clientWidth
          let tableHeaderContainer = document.getElementById('table2HeaderContainer').clientWidth
          let paddingOnInnerDiv = 40
          this.modifyTable2HeightByData('#table2HeaderContainer')
          this.modifyTable2HeightByData('#table2BodyContainer div')
          return `${tableContainerDiv - tableHeaderContainer - paddingOnInnerDiv}px`
        }
      } catch (e) {
        return 0
      }
    },
    getTable1ContainerWidth () {
      try {
        if (
          document.getElementById('table1ContainerDiv') &&
          document.getElementById('table1HeaderContainer')
        ) {
          let tableContainerDiv = document.getElementById('table1ContainerDiv').clientWidth
          let tableHeaderContainer = document.getElementById('table1HeaderContainer').clientWidth
          let paddingOnInnerDiv = 40
          this.modifyTableHeightByData('#table1HeaderContainer')
          this.modifyTableHeightByData('#table1BodyContainer div')
          return `${tableContainerDiv - tableHeaderContainer - paddingOnInnerDiv}px`
        }
      } catch (e) {
        return 0
      }
    },
    updateChanges (record) {
      let regex = new RegExp(/^\d{1,4}(\.\d{1,2})?$/)
      let response = {result: false}
      if (!regex.test(record.value)) {
        response = {result: true, msg: 'Value is not accepted.'}
      }
      if (response.result) {
        this.processData()
        this.updateTable1BySlider1Changes()
        this.updateTable1BySlider2Changes()
        this.pop({
          header: 'ERROR!',
          message: response.msg,
          type: 'ERROR'
        })
      } else {
        let result = this.performCalculation(this.table1Data[1], record)
        if (result.opt) {
          this.pop({
            header: 'ERROR!',
            message: result.msg,
            type: 'ERROR'
          })
          this.processData()
          this.updateTable1BySlider1Changes()
          this.updateTable1BySlider2Changes()
        } else {
          this.refreshColumnData(record)

          // this.editedItemRecord = record
          let inputObj = {
            itemId: this.duplicatedItemName.id,
            storeLevel: this.storeLevel,
            period: this.period,
            tagNo: this.table1Data[1].tagNo,
            updatedData: this.updatedData
          }
          // console.log(JSON.stringify(inputObj), this.table1Data[1])
          this.fetchCalculationFields(inputObj)
          // console.log(JSON.stringify(this.updatedData))
        }
      }
    },
    refreshColumnData (record) {
      const { index, value } = record
      // let tableColumn1 = this.table1Data[1]
      // let obj = {[VENDOR_ALLOWANCE_PERCENT]: tableColumn1[this.vaAllowancePercentPos].value, [RETAIL_SAVING_PERCENT]: tableColumn1[this.retailSavingPercentPos].value}
      // // console.log(obj)
      // let data = this.getOriginalData(obj)
      // // console.log(data)
      // this.performCalculation(data, tableColumn1, record)
      let updatedKey = this.table1Header[index].key
      // this.updatedData.itemId = this.duplicatedItemName.id
      this.updatedData[updatedKey] = value
      // let keys = Object.keys(this.updatedData)
      // let notEmpty = false
      // if (keys.length) {
      //   for (let i = 0; i < keys.length; i++) {
      //     if (this.updatedData[keys[i]]) {
      //       notEmpty = true
      //     } else {
      //       notEmpty = false
      //       break
      //     }
      //   }
      //   if (notEmpty) {
      //     this.hasChanges = true
      //   } else {
      //     this.hasChanges = false
      //   }
      // } else {
      //   this.hasChanges = false
      // }
    },
    modifyTableHeightByData (el) {
      let tableHeightAdjustment = new TableHeightByFixedWidth(
        this.table1Data,
        this.table1BodyWidth,
        '1.5rem',
        '1rem'
      )
      tableHeightAdjustment.modifyTableRowHeight(el)
    },
    modifyTable2HeightByData (el) {
      let tableHeightAdjustment = new TableHeightByFixedWidth(
        this.table2Data,
        this.scrollableChildrenWidth,
        '1.5rem',
        '1rem'
      )
      tableHeightAdjustment.modifyTableRowHeight(el)
    }
  }
}
</script>
<style scoped>
  .upper-parent {
    flex-direction: row;
    display: flex;
    flex: 1
  }

  .upper-parent-child1 {
    display: flex;
    flex: 2
  }

  .upper-parent-child2 {
    display: flex;
    flex: 8
  }
  .slider-title {
    font-size: 1.4rem;
    text-transform: uppercase;
    letter-spacing: .1rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    padding-left: 1rem;
    font-family: bold;
    margin-left: 1.5rem;
  }
  .marginLeft {
    margin-left: 2rem;
  }
  .marginRight {
    margin-right: 2rem;
  }
  .scrollable {
    overflow: auto;
  }
  .left-align {
    text-align: left;
  }
  .margin-fix {
    margin-left: -.5rem;
  }
  .v-top {
    vertical-align: top;
  }
  .change-header-title {
    background-color: #f3f3f3;
    margin-top: 1rem;
    padding: 1rem;
    text-align: center;
    color: #404347;
    text-transform: uppercase;
    font-size: 1.5rem;
  }
  .switch-parent {
    margin-top: 4rem;
    margin-left: 6%;
    font-size: 1.5rem;
  }
  .padding1 {
    padding: 1rem;
  }
  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 25px;
  }
  .switch:hover {
    cursor: pointer;
  }
  .switch input {
    display: none;
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }
  .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }
  /*.switch input:checked + .slider {
    background-color: #2196F3;
  }*/

  .switch input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
  }

  .switch input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  ul {
    list-style-type: none;
    text-align: center;
    font-size: 1.5rem;
    padding-left: 0;
    background-color: '#eeeeee';
    margin-top: 0;
  }

  li {
    padding-left: 2rem;
    padding-right: 2rem;
    padding-top: .5rem;
    padding-bottom: .5rem;

  }

  li:hover {
    background: #eeeeee;
    cursor: pointer;
  }

  .offer-name {
    text-align: center;
    font-size: 1.4rem;
    padding: 1rem;
    background: #f3f3f3;
    word-wrap: break-word;
    color: #4d4d4d;
  }
  .item-scroll {
    height: 22rem;
    overflow: auto;
  }
  .graph-parent {
    /*display: inline-block;*/
    width: 100%;
  }
  .radio-container label {
    font-size: 1.2rem;
    color: black;
  }
  .radio-container {
    width: 20%;
    margin-top: 2%;
    margin-left: 6%;
    display: inline-block;
  }
  .graph-container {
    display: inline-block;
    /*margin-left: 6%;*/
    width: 70%;
    vertical-align: top;
  }
  .scrollable-x {
    overflow-x: auto;
  }
  .table1-space {
    margin: 2rem 1rem;
    text-align: center;
  }
  .margin_bottom-2 {
    margin-bottom: 2rem;
  }
  .same-line {
    vertical-align: top;
    display: inline-block;
  }
  .itemsContainer {
    background-color: '#f1f1f1';
  }.
  .margin-top-3 {
    margin-top: 3rem;
  }
  ul {
    z-index: 4
  }
  .text-align-left {
    text-align: left;
  }
  .item-text {
    font-size: 1.2rem;
    color: #8c8c8c;
    padding-top: 0.5rem
  }
</style>



// WEBPACK FOOTER //
// Simulation.vue?6b682387